/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Edytuj",
  "i18n.actionBar.removeImage": "Usuń",
  "i18n.actionBar.swapImage": "Zamień",
  "i18n.additionalInfoItemLayers.smartSorted.new": "Nowość!",
  "i18n.additionalProducts.addToCart": "Dodaj do zamówienia",
  "i18n.additionalProducts.frame.description": "Wysokiej jakości rama aluminiowa: matowe srebro, prawdziwe szkło premium, bez potrzeby klejenia",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Rada:",
  "i18n.additionalProducts.frame.subtitle": "Gotowe puzzle to wspaniała pamiątka, a dzięki naszej <b>ramie</b> zostaną pięknie wyeksponowane.",
  "i18n.additionalProducts.frame2023.description": "Wysokiej jakości rama z płyty drewnopochodnej – prosty montaż, bez szkła, w zestawie klej do puzzli",
  "i18n.additionalProducts.framePlastic.description": "Wysokiej jakości rama aluminiowa: matowe srebro, antyrefleksyjne szkło syntetyczne, bez potrzeby klejenia",
  "i18n.additionalProducts.glue.description": "Do maksymalnie dwóch puzzli po 1000 elementów, w zestawie gąbka do nakładania",
  "i18n.additionalProducts.glue.hook": "Aby Twoje puzzle stały się obrazem.\nTrwale skleja i chroni.",
  "i18n.additionalProducts.roll.description": "Do puzzli od 48 do 2000 elementów",
  "i18n.additionalProducts.roll.hook": "Brak wolnego stołu? Żaden problem.\nZwiń puzzle, schowaj je i kontynuuj później.",
  "i18n.adventCalendarOverlay.activate": "Wyświetl podgląd 24 okienek.",
  "i18n.adventCalendarOverlay.deactivate": "Ukryj podgląd 24 okienek.",
  "i18n.adventCalendarOverlay.notice": "( Liczby i linie nie zostaną wydrukowane.)",
  "i18n.button.addToCart": "Dodaj do koszyka",
  "i18n.button.apply": "Zastosuj",
  "i18n.button.back": "Wstecz",
  "i18n.button.cancel": "Anuluj",
  "i18n.button.cancelAndFix": "Zmień teraz",
  "i18n.button.chooseSmartSorted": "Tak, wezmę SMART SORTED. ",
  "i18n.button.close": "Zamykaj",
  "i18n.button.continue": "Dalej",
  "i18n.button.createNewTextPlaceholders": "Wprowadź tekst",
  "i18n.button.ignore": "Pomijaj",
  "i18n.button.ignoreAndContinue": "Mimo to, dalej",
  "i18n.button.mobile.createNewTextPlaceholders": "Tekst",
  "i18n.button.noChanges": "Nie, dziękuję. Zamknij okno.",
  "i18n.button.ok": "W porządku",
  "i18n.button.photos": "Zdjęcia",
  "i18n.button.retry": "Spróbuj ponownie",
  "i18n.button.uploadPhotos": "Prześlij zdjęcie / zdjęcia",
  "i18n.button.withSmartSorted": "Tak, wezmę SMART SORTED. ",
  "i18n.button.withoutSmartSorted": "Nie, dziękuję. Zamknij okno.",
  "i18n.control.colorChooser.color": "Kolor",
  "i18n.control.fontChooser.placeholderText": "Czcionka",
  "i18n.control.imageQuality.checkImages": "Sprawdź rozdzielczość zdjęć",
  "i18n.control.imageQuality.imageSuitability": "Rozdzielczość zdjęcia",
  "i18n.control.imageQuality.indicatorAltText": "Rozdzielczość zdjęcia",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Wybierz szablon ",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Aby uzyskać lepszą czytelność, skróć długość tekstu / linii.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Wybrana czcionka jest za duża dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Osiągnięto maksymalny możliwy rozmiar czcionki dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Osiągnięto minmalny możliwy rozmiar czcionki dla tego tekstu.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Proszę wstawić przerwę w linii",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Kontynuuj pisanie w poniższym zdaniu lub powiększ pole tekstowe",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Prosimy o sprawdzenie textu. Ta czcionka nie obsługuje wszystkich znaków.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Maksymalna liczba znaków została osiągnięta",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Aby uzyskać lepszą czytelność, skróć długość tekstu / linii.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Proszę powiększ pole tekstowe",
  "i18n.dialog.deletePlaceholder.message": "Tego kroku nie można cofnąć",
  "i18n.dialog.deletePlaceholder.title": "Chcesz usunąć symbol zastępczy?",
  "i18n.dialog.error.title": [
    "Wystąpił błąd",
    "Niektóre błędy wystąpiły",
    "Niektóre błędy wystąpiły"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Rozdzielczość tego zdjęcia jest za słaba na optymalną jakość druku!",
  "i18n.dialog.smartSorted.message": "Z sortowaniem wstępnym SMART SORTED ułożysz bez trudu innowacyjnym sposobem puzzle z 1000 elementów, również nie widząc wzoru motywu",
  "i18n.dialog.smartSorted.title": "Sukces w układaniu puzzli gwarantowany",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Kliknij \"{{text}}\", aby zmienić tytuł pudełka.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Tytuł pudełka nie został zmieniony",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Dalej bez tytułu w pudełku",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Proszę wstawić zdjęcie, klikając na symbol zastępczy",
    "Proszę wstawić zdjęcia klikając na symbole zastępcze",
    "Proszę wstawić zdjęcia klikając na symbole zastępcze"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Jeden element zastępczy jest nadal pusty",
    "Niektóre symbole zastępcze są nadal puste",
    "Niektóre symbole zastępcze są nadal puste"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Symbol zastępczy nie został zmieniony.",
    "Niektóre symbole zastępcze nie zostały zmienione.",
    "Niektóre symbole zastępcze nie zostały zmienione."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Kliknij zdjęcie i symbol zastępcze tekstu, aby zmienić kolaż",
    "Kliknij zdjęcia i symbole zastępcze tekstu, aby zmienić kolaż",
    "Kliknij zdjęcia i symbole zastępcze tekstu, aby zmienić kolaż"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Symboli zastępczych nie został zmieniony.",
    "Kilka symboli zastępczych nie zostali zmienionych.",
    "Kilka symboli zastępczych nie zostali zmienionych."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Kliknij symbol zastępczy tekstu, aby zmienić tekst",
    "Kliknij symbole zastępcze tekstu, aby zmienić teksty",
    "Kliknij symbole zastępcze tekstu, aby zmienić teksty"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Symbol zastępczy tekstu nie został zmieniony",
    "Niektóre symbole zastępcze tekstu nie zostały zmienione",
    "Niektóre symbole zastępcze tekstu nie zostały zmienione"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Nie zmienione symbole zastępcze",
  "i18n.error.additionalInfoItemsError.message": "Błąd ładowania warstwy informacyjnej",
  "i18n.error.additionalInfoItemsError.title": "Błąd ładowania",
  "i18n.error.deprecatedBrowserError.message": "Przeglądarka, z której korzystasz, nie jest już obsługiwana. Prosimy o aktualizację do nowszej wersji.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Projekt został przerwany na dłuższy czas, niestety nie może być teraz kontynuowany. Prosimy o ponowne uruchomienie projektu.",
  "i18n.error.designerExpiredError.title": "Projekt został przerwany",
  "i18n.error.fontLoadingError.message": "Błąd ładowania czcionka",
  "i18n.error.fontLoadingError.title": "Błąd ładowania",
  "i18n.error.imageLoadingError.message": "Jedno zdjęcie nie zostało wstawione. Został usunięty z obszaru projektu i galerii.",
  "i18n.error.imageLoadingError.title": "Błąd pobierania",
  "i18n.error.imageProvisionError.message": "Nie można przetworzyć zdjęcia lub niektórych zdjęć. Rodzaj mediów prawdopodobnie nie jest odpowiedni.",
  "i18n.error.imageProvisionError.title": "Nieprzetworzone zdjęcie",
  "i18n.error.imageSelectionError.message": "Nie można przetworzyć \"{{reference1}}\"",
  "i18n.error.imageSelectionError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.imageSizeLimitExceededError.message": "Załadowane zdjęcie ma za duży rozmiar.\nProsimy zmniejszyć je do rozmiaru mniejszego niż 180 megapikseli i załadować ponownie.",
  "i18n.error.imageSizeLimitExceededError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.imageUploadError.message": "Wystąpił problem z połączeniem internetowym. Spróbuj ponownie później.",
  "i18n.error.imageUploadError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.inlineSVGLoadingError.message": "Nie można załadować ramki tolerancji",
  "i18n.error.inlineSVGLoadingError.title": "Błąd pobierania",
  "i18n.error.invalidCharConfigError.message": "Tego typu czcionki nie można użyć, wybierz inną czcionkę.",
  "i18n.error.invalidCharConfigError.title": "Typ czcionki nie nadaje się",
  "i18n.error.malformedProductError.message": "Jeden lub więcej produktów nie zostało przeniesionych na serwer. Prawdopodobnie produkt nie jest już dostępny albo proces projektowania trwał zbyt długo. Przykro nam. Zacznij projektowanie raz jeszcze.",
  "i18n.error.malformedProductError.title": "Błąd ładowania",
  "i18n.error.notInStockError.message": "Wybrany produkt jest obecnie niedostępny.\nKlikając nasze logo w lewym górnym rogu, zostaniesz przeniesiony na stronę główną, gdzie możesz wybrać inny produkt.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Twoje połączenie internetowe zostało przerwane. Możesz kontynuować projektowanie swojego produktu zaraz po przywróceniu połączenia.",
  "i18n.error.templateLoadingError.message": "Nie można załadować szablonu \"{{ error.reference[0] }}\". Spróbuj ponownie później.",
  "i18n.error.templateLoadingError.title": "Błąd pobierania",
  "i18n.error.transformationError.message": "Transformacja nie mogła zostać przetworzona",
  "i18n.error.transformationError.title": "Błąd transformacji",
  "i18n.error.traudlLoadingError.message": "Spróbuj ponownie lub użyj innego zdjęcia.",
  "i18n.error.traudlLoadingError.title": "Nie udało się zastosować filtra AI.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" ma nieodpowiedni typ mediów.",
  "i18n.error.unsupportedMediaTypeError.title": "Błąd podczas przesyłania zdjęć",
  "i18n.error.uploadProductError.message": "Produkt lub niektórych produktów nie można przenieść na serwer. Spróbuj ponownie później.",
  "i18n.error.uploadProductError.title": "Błąd transferu",
  "i18n.error.zoomModeError.message": "Tekst z poprzedniego projektu nie mógł zostać przyjęty. Wprowadź nowy tekst.",
  "i18n.error.zoomModeError.title": "Tekst nie został przyjęty",
  "i18n.gallery.uploadPhotos.info": "Kliknij na \"prześlij zdjęcia\"",
  "i18n.gallery.uploadProgress": [
    "Zdjęcie zostanie przesłane",
    "Zdjęcia zostaną przesłane",
    "Zdjęcia zostaną przesłane"
  ],
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Zaoszczędzisz",
  "i18n.price.total": "Cena całkowita",
  "i18n.priceDisplay.times": [
    "{{value}} sztuk po {{pricePerUnit}} zł każda",
    "{{value}} sztuk po {{pricePerUnit}} zł każda",
    "{{value}} sztuk po {{pricePerUnit}} zł każda"
  ],
  "i18n.progress.stepAdditionalProducts": "Dodatki (opcjonalnie)",
  "i18n.progressOverlay.message.lines.one": "Dziękujemy za starannie przygotowany projekt.",
  "i18n.progressOverlay.message.lines.two": "Przygotujemy następujący krok...",
  "i18n.template.insertText": "Wpisz tutaj tekst",
  "i18n.toolbox.gallery.title": "Wybierz zdjęcia",
  "i18n.toolbox.image.title": "Edytuj zdjęcie",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 zdjęcie",
    "{{value}} zdjęcia",
    "{{value}} zdjęć"
  ],
  "i18n.toolbox.layout.title": "Zmień szablon",
  "i18n.toolbox.layout.triggerText": "Szablon",
  "i18n.toolbox.preview.title": "Podgląd 3D",
  "i18n.toolbox.productChooser.title": "Zmień produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Edytuj tekst"
};


export class LocalePlPL {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
